import {
  CmpInvoiceDetailFieldsFragment,
  CmpInvoiceKindEnum,
} from "../../../../graphql/types";

type EventInvoiceForCardAvailability = Pick<
  CmpInvoiceDetailFieldsFragment["invoice"],
  | "eventId"
  | "eventRegistrationId"
  | "eventSponsorshipRequestId"
  | "id"
  | "invoiceKind"
>;

type EventInvoiceDetailForCardAvailability = {
  invoice: EventInvoiceForCardAvailability & {
    paymentRules?: Pick<
      NonNullable<CmpInvoiceDetailFieldsFragment["invoice"]["paymentRules"]>,
      "creditCardAllowed"
    > | null;
  };
};

export const getManageEventInvoiceCardAvailability = ({
  actionAllowed,
  detail,
  row,
}: {
  actionAllowed: boolean;
  detail?: EventInvoiceDetailForCardAvailability | null;
  row?: EventInvoiceForCardAvailability | null;
}): boolean => {
  // Generic invoice actions deliberately reject event payments. The event
  // modal checks the linked sale and uses the source-owned checkout mutation.
  if (
    !actionAllowed ||
    !detail ||
    !row ||
    detail.invoice.id !== row.id ||
    detail.invoice.invoiceKind !== row.invoiceKind ||
    !detail.invoice.eventId?.trim() ||
    detail.invoice.paymentRules?.creditCardAllowed !== true
  ) {
    return false;
  }

  if (row.invoiceKind === CmpInvoiceKindEnum.EventRegistration) {
    return Boolean(detail.invoice.eventRegistrationId?.trim());
  }

  if (row.invoiceKind === CmpInvoiceKindEnum.EventSponsorship) {
    return Boolean(detail.invoice.eventSponsorshipRequestId?.trim());
  }

  return false;
};
